const CONFIRMATION_KEY = "ccg_enquiry_confirmation_v1";
const TRACKED_KEY = "ccg_enquiry_conversions_v1";
const CONFIRMATION_MAX_AGE_MS = 24 * 60 * 60 * 1000;

const cleanText = (value, maxLength = 180) =>
  String(value == null ? "" : value)
    .trim()
    .slice(0, maxLength);

const cleanCount = (value) => {
  if (value === "" || value == null) return "";
  const count = Number(value);
  return Number.isFinite(count) && count >= 0 ? Math.round(count) : "";
};

export const buildEnquiryConfirmation = (details = {}) => ({
  refCode: cleanText(details.refCode || "ENQ", 60),
  brand: cleanText(details.brand, 60),
  pickup: cleanText(details.pickup),
  dropoff: cleanText(details.dropoff),
  passengers: cleanCount(details.passengers),
  bags: cleanCount(details.bags),
  pickupTime: cleanText(details.pickupTime, 60),
  vehicle: cleanText(details.vehicle, 100),
  returnRequested: details.returnRequested === true,
  contactFlowV2: details.contactFlowV2 === true,
  submittedAt: new Date().toISOString(),
});

export const saveEnquiryConfirmation = (details = {}) => {
  const confirmation = buildEnquiryConfirmation(details);
  if (typeof window === "undefined") return confirmation;
  try {
    window.sessionStorage.setItem(CONFIRMATION_KEY, JSON.stringify(confirmation));
  } catch (_error) {
    // Confirmation navigation must still succeed if storage is unavailable.
  }
  return confirmation;
};

export const readEnquiryConfirmation = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(CONFIRMATION_KEY);
    if (!raw) return null;
    const confirmation = JSON.parse(raw);
    const submittedAt = new Date(confirmation?.submittedAt).getTime();
    if (!submittedAt || Date.now() - submittedAt > CONFIRMATION_MAX_AGE_MS) {
      window.sessionStorage.removeItem(CONFIRMATION_KEY);
      return null;
    }
    return confirmation;
  } catch (_error) {
    return null;
  }
};

export const trackEnquiryConversion = (details = {}) => {
  if (typeof window === "undefined") return;
  const refCode = cleanText(details.refCode, 60);
  if (!refCode) return;

  try {
    const tracked = JSON.parse(window.sessionStorage.getItem(TRACKED_KEY) || "[]");
    if (Array.isArray(tracked) && tracked.includes(refCode)) return;
    window.sessionStorage.setItem(
      TRACKED_KEY,
      JSON.stringify([...(Array.isArray(tracked) ? tracked : []), refCode].slice(-50))
    );
  } catch (_error) {
    // Tracking remains best-effort and must never affect enquiry submission.
  }

  const eventParameters = {
    transaction_id: refCode,
    enquiry_reference: refCode,
    enquiry_brand: cleanText(details.brand, 60),
    enquiry_vehicle: cleanText(details.vehicle, 100),
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "enquiry_submitted", ...eventParameters });

  if (typeof window.gtag === "function") {
    window.gtag("event", "generate_lead", eventParameters);
    const sendTo = process.env.REACT_APP_GOOGLE_ADS_ENQUIRY_SEND_TO;
    if (sendTo) {
      window.gtag("event", "conversion", { send_to: sendTo, transaction_id: refCode });
    }
  }
};

export const completeEnquiry = (navigate, details = {}) => {
  const confirmation = saveEnquiryConfirmation(details);
  trackEnquiryConversion(confirmation);
  navigate("/thank-you", { replace: true, state: { confirmation } });
};
